// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivacyText_wrapper__+lDmT","section":"PrivacyText_section__Mv-+i"};